import styles from "../opsDashboard.module.css";

/**
 * An empty table is the EXPECTED, healthy state here — most of these tables are empty
 * most days, and MPN-1840 asks for an all-empty dashboard to "read as a win, not a broken
 * page". So this follows the muted icon-over-caption pattern the contract panels use
 * rather than shouting a bold sentence into the middle of the card.
 */
export function EmptyState({ title, icon }: { title: string; icon?: string }) {
    return (
        <div className={styles.empty}>
            <i className={`bi ${icon ?? "bi-check2-circle"} ${styles.emptyIcon}`} />
            <div className={styles.emptyTitle}>{title}</div>
        </div>
    );
}
